import React from 'react'
import createUsePollingWithCache from 'hooks/createUsePollingWithCache'
import { getData as apiGetData } from 'api/Api'

type BlockerUseCountData = {
  Id: number;
  Boards: {
    BoardId: number;
    Count: number;
  }[]
}[]

const usePollingWithCache = createUsePollingWithCache<number>({
  getData: (ids, setData) => {
    apiGetData('BlockersUseCount', { ids }).then((data: BlockerUseCountData) => {
      ids.forEach(id => {
        let count = 0

        const BlockerCount = data.find(BlockerCount => BlockerCount.Id === Number(id))

        if (BlockerCount) {
          count = BlockerCount.Boards.reduce((acc, BoardCount) => acc + BoardCount.Count, 0)
        }

        setData(id, count)
      })  
    })
  }
})

type RenderData = {
  count: number | null | undefined;
}

type Props = {
  blockerId: number;
  children?: (data: RenderData) => React.ReactNode;
}

const BlockerUseCount: React.FC<Props> = ({
  blockerId,
  children,
}) => {
  const count = usePollingWithCache(String(blockerId))

  if (children) {
    return children({
      count,
    })
  }

  return (count as any) || null
}

export default BlockerUseCount
